import { IStore } from '@aurelia/state';
import { lifecycleHooks, resolve } from 'aurelia';
import { IRouteViewModel, Params, RouteNode } from '@aurelia/router-lite';

import { ActionNames, UpdateCurrentRouteName } from '../../state';

@lifecycleHooks()
export class RouteNameHook {
    private readonly store: IStore<{}, UpdateCurrentRouteName> = resolve(IStore);

    public loading(
        _viewmodel: IRouteViewModel,
        _params: Params,
        next: RouteNode
    ) {
        this.store.dispatch({ type: ActionNames.UPDATE_CURRENT_ROUTE_NAME, value: next.component.name as string });
    }
}
